import script from "./ArticlesBodySkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesBodySkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesBodySkeleton.vue?vue&type=style&index=0&id=61e6e733&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e6e733"]])

export default __exports__